/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { getServicesAll, getServicesQtd } from '../../../../../../services/servicesService';
import { Loading } from '../../../../../components/Loadings/loading';
import { SearchInputV3 } from '../../../../../components/SearchInputV3';
import { OrderServiceToolbar } from '../../../../../../components/OrderServiceChecklist/OrderServiceToolbar';
import listLayoutStyles from '../../../../../components/ListTableLayout/listTableLayout.module.css';
import { useToast } from '../../../../../components/Toats';
import { ModalDeleteOS } from '../ModalDeleteOS';
import { ModalDetailsOS } from '../ModalDetailsOS';
import { OrderServiceChecklistBoard } from '../../../../../../components/OrderServiceChecklist/OrderServiceChecklistBoard';
import { ClientOrderServiceList } from '../../../../../../components/OrderServiceChecklist/ClientOrderServiceList';
import checklistLayoutStyles from '../../../../../../components/OrderServiceChecklist/orderServiceChecklistLayout.module.css';
import { ModalAddUpdateOrderService } from './components/ModalAddEditOrderService';
import { useAuth } from '../../../../../../modules/auth';
import { getCollaboratosAll } from '../../../../../../services/collaboratorsService';
import { getClientAll } from '../../../../../../services/clientService';
import { ModalTemplateOS } from '../ModalTemplateOS';

import useSize from '../../../../../../hooks/useSize';
import { PaginationTablePlants } from '../../../../../dashboard/TablePlants/components/Pagination';

type Props = {
    className: string;
    refreshPage : boolean; 
    setRefreshPage: any;
  }


type Paginations = {
  page: number,
  limit: number,
  total: number,
  qtdPages: number
}

type SetPaginations = {
  start: number;
  end: number;
}
  
  const TableOrderOfService: React.FC<Props> = ({className, refreshPage}) => {
    
    const [filterName, setFilterName] = useState<string>("");
    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  //   const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState<boolean>(false)
    //const [showCreateAppModalDetails, setShowCreateAppModalDetails] = useState<boolean>(false)
    const [myOrderService, setMyOrderService] = useState<any | null>(null);
    const [orderOfServices, setOrderOfServices] = useState<any>([]);
    const [orderOfServicesQtd, setOrderOfServicesQtd] = useState<any>([]);
    const { toggleToast } = useToast();
    const [orderOfServiceLoading, setOrderOfServicesLoading] = useState<boolean>(false)
    const [orderOfServiceQtdLoading, setOrderOfServicesQtdLoading] = useState<boolean>(false)
    const [largura, setLargura] = useState(window.innerWidth);
    const [showModalDetails, setShowModalDetails] = useState<boolean>(false)
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false)
    const [showModalTemplate, setShowModalTemplate] = useState<boolean>(false)
    const [filterStatus, setFilterStatus] = useState<string>("")
    const [collaborators, setCollaborators] = useState<any[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [filterDateInit, setFilterDateInit] = useState<any>("");
    const [filterDateEnd, setFilterDateEnd] = useState<any>("");
    const [filterCollaborator, setFilterCollaborator] = useState<any>("");
    const [filterClient, setFilterClient] = useState<any>("");
    const {currentUser} = useAuth();
    const {height, width} = useSize();

    const [pagination, setPagination] = useState<Paginations>({
      page: 1,
      limit: 50,
      total: 0,
      qtdPages: 1
    });
  
    const [qtd, setQtd] = useState<SetPaginations>({
      start: 0,
      end: 50,
    });

  
  const getReportServices = async () => {
    try {
      setOrderOfServicesLoading(true)
      const myServices = await getServicesAll(
        filterStatus,
        "",
        "",
        filterCollaborator,
        filterDateInit,
        filterDateEnd,
        filterClient,
        filterName
      )
      setOrderOfServices(myServices)
  
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar as ordens de serviço!", "error")
    }finally{
      setOrderOfServicesLoading(false)
    }
  }

  const getServicesQtdAll = async () => {
    try {
      setOrderOfServicesQtdLoading(true)
      const myServicesQtd = await getServicesQtd()
      setOrderOfServicesQtd(myServicesQtd)
  
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os status!", "error")
    }finally{
      setOrderOfServicesQtdLoading(false)
    }
  }

  const getUsersAllCollaborators = async () => {
    try {
      //setLoadingCollaborators(true)
      const collaboratos = await getCollaboratosAll()
      setCollaborators(collaboratos)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os colaboradores. ", "error")

    }finally{
      //setLoadingCollaborators(false)
    }
  }

  const getClients = async () => {
    try {
      const myClient = await getClientAll()
      setClients(myClient)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os clientes!", "error")
    }finally{
    }
  }
  
  
  const refresh = () => {
    getReportServices()
    getServicesQtdAll()
  }

  const adjustOrderServiceDates = (orderService: any) => {
    if (orderService.dateInit) {
      const date = new Date(orderService.dateInit)
      date.setHours(date.getHours() + 3)
      orderService.dateInit = date.toISOString()
    }
    if (orderService.dateEnd) {
      const date = new Date(orderService.dateEnd)
      date.setHours(date.getHours() + 3)
      orderService.dateEnd = date.toISOString()
    }
    return orderService
  }

  const openOrderDetails = (orderService: any) => {
    setMyOrderService(orderService)
    setShowModalDetails(true)
  }

  const prepareOrdersList = (items: any[]) => {
    if (!items?.length) return []
    return items.map((order) => adjustOrderServiceDates(order))
  }

  const isClientUser = currentUser?.role?.slug === 'CLIENTE'

  const checklistBoardProps = {
    filterStatus,
    orderOfServicesQtd,
    onOpenDetails: openOrderDetails,
    refresh,
    setShowModalDelete,
    setMyOrderService,
    setShowCreateAppModal,
    setShowModalTemplate,
  }
  
  const atualizarTamanhoDaTela = () => {
    setLargura(window.innerWidth);
  };
  
  useEffect(() => {
    getReportServices()
    
    window.addEventListener('resize', atualizarTamanhoDaTela);
    return () => {
      window.removeEventListener('resize', atualizarTamanhoDaTela);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    //getReportServices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  
  useEffect(() => {
    getReportServices()
    getServicesQtdAll()
    getUsersAllCollaborators()
    getClients()
    //getReportServices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPage]);
  
  useEffect(() => {
    getReportServices()
  }, [
    filterStatus, 
    filterCollaborator, 
    filterDateEnd, 
    filterDateInit, 
    filterClient,
    filterName
  ]);

  if (orderOfServiceQtdLoading) {
    return (
      <div className='spinnerLoadingDashboard'>
        <Loading myClass='spinner-border spinnerDashboard'/>
      </div>
    );
  }

    
    return (
      <div className={`${className}`} style={{height: '95%'}}>
        <div className='py-3' style={{height: '100%'}}>
          <OrderServiceToolbar
            search={
              <SearchInputV3
                className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
                placeholder='Buscar por Nº O.S, título ou cliente'
                setMySearch={setFilterName}
                style={{width: '100%'}}
              />
            }
            filterStatus={filterStatus}
            setFilterStatus={setFilterStatus}
            orderOfServicesQtd={orderOfServicesQtd}
            filterDateInit={filterDateInit}
            setFilterDateInit={setFilterDateInit}
            filterDateEnd={filterDateEnd}
            setFilterDateEnd={setFilterDateEnd}
            filterCollaborator={filterCollaborator}
            setFilterCollaborator={setFilterCollaborator}
            filterClient={filterClient}
            setFilterClient={setFilterClient}
            collaborators={collaborators}
            clients={clients}
            showClientFilter={!isClientUser}
            canCreate={!isClientUser}
            onCreate={() => setShowCreateAppModal(true)}
          />
          <div
            className={`table-responsive ${checklistLayoutStyles.osTableWrap}`}
            style={{height: '94%', overflow: 'auto'}}
          >
            <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0'>
                {
                  orderOfServiceLoading ? 
                    <tbody>
                      <tr>
                        <td>
                          <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
                        </td>
                      </tr>
                    </tbody>
                  : (
                    <tbody>
                      <tr>
                        <td colSpan={6} className={checklistLayoutStyles.osChecklistCell}>
                          {orderOfServices && orderOfServices.length > 0 ? (
                            isClientUser ? (
                              <ClientOrderServiceList
                                orders={prepareOrdersList(orderOfServices)}
                                onOpenDetails={openOrderDetails}
                              />
                            ) : (
                              <OrderServiceChecklistBoard
                                orders={prepareOrdersList(orderOfServices)}
                                {...checklistBoardProps}
                              />
                            )
                          ) : (
                            <div className={checklistLayoutStyles.osChecklistEmpty}>
                              <span className='text-muted fw-semibold fs-5'>
                                Ordens de serviços não encontradas!
                              </span>
                            </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  )
                }
                
            </table>
          </div>

          <PaginationTablePlants 
            pagination={pagination}
            setPagination={setPagination}
            qtd={qtd}
          />
        </div>

          <ModalAddUpdateOrderService
            show={showCreateAppModal}
            id={myOrderService ? myOrderService.id : undefined} 
            data={myOrderService ? myOrderService : undefined}
            handleClose={() => {
              setMyOrderService(null)
              setShowCreateAppModal(false)
              refresh()
            }} 
          />
          <ModalDeleteOS
            show={showModalDelete}
            data={myOrderService ? myOrderService : undefined}
            id={myOrderService ? myOrderService.id : undefined} 
            handleClose={() => {
              setMyOrderService(null)
              setShowModalDelete(false)
              refresh()
            }} 
          />

          <ModalDetailsOS
            show={showModalDetails}
            data={myOrderService ? myOrderService : undefined}
            id={myOrderService ? myOrderService.id : undefined} 
            handleClose={() => {
              setMyOrderService(null)
              setShowModalDetails(false)
              refresh()
            }} 
          />
  
        {<ModalTemplateOS
          show={showModalTemplate}
          id={myOrderService ? myOrderService.id : undefined} 
          handleClose={() => {
            setMyOrderService(null)
            setShowModalTemplate(false)
            refresh()
          }} 
        />}
          {/* <ModalDetailsClient
            show={showCreateAppModalDetails}
            id={myClient ? myClient.id : undefined} 
            handleClose={() => {
              setMyClient(null)
              setShowCreateAppModalDetails(false)
              refresh()
            }} 
          /> */}
        {/* begin::Body */}
      </div>
    )
  }
  
  export {TableOrderOfService}